import React, { useEffect, useState } from 'react';
import useTranslationLgs from '@hooks/i18n/useTranslation.tsx';
import ButtonTag from '@components/framework/tags/ButtonTag.tsx';
import { SecuredConfig } from '@components/security/securedDecoration';
import { PolandSentRequest } from '@api/ringil-api.v2.tsx';
import { Field } from '@components/framework/formfield/Field.tsx';
import { InputText } from 'primereact/inputtext';
import MultipleValues from '@components/ringil3/HelperComponents/MultipleValues.tsx';

interface ComponentProps {
  secured?: SecuredConfig;
  value: PolandSentRequest;
  onChange: (value: PolandSentRequest) => void;
  readOnly?: boolean;
  dataTestId?: string;
  dataTestIdDeclarationRefNumberInput?: string;
  dataTestIdCarrierUpdateKeyInput?: string;
  dataTestIdSave?: string;
  dataTestIdClose?: string;
}

const PolandSentTag: React.FC<ComponentProps> = ({ secured,
  value,
  onChange,
  readOnly,
  dataTestId,
  dataTestIdDeclarationRefNumberInput,
  dataTestIdCarrierUpdateKeyInput,
  dataTestIdSave,
  dataTestIdClose,
}) => {
  const [internalValue, setInternalValue] = useState(value);
  const { tr } = useTranslationLgs();

  // The value can arrive after mount (the create form prefills asynchronously), so the working copy
  // has to follow it rather than keeping whatever was there on the first render.
  useEffect(() => {
    setInternalValue(value);
  }, [value]);

  const renderButtonTagValue = () => {
    if (value) return <MultipleValues values={[internalValue?.sentNumber, internalValue?.sentCarrierUpdateKey]}></MultipleValues>;
    return null;
  };

  return (
    <>
      <ButtonTag secured={secured}
        label={tr('PolandSentTag.title', 'Sent carrier')}
        value={renderButtonTagValue()}
        onSave={(onSuccess) => {
          onChange(internalValue);
          onSuccess();
        }}
        readonly={readOnly}
        popupWidth={'400px'}
        autoClose
        dataTestId={dataTestId}
        dataTestIdSave={dataTestIdSave}
        dataTestIdClose={dataTestIdClose}
      >

        <>
          <Field label={tr('PolandSentTag.sentNumber', 'Number')}>
            <InputText
              value={internalValue?.sentNumber}
              onChange={e => setInternalValue(draft => {
                if (!draft) return { sentNumber: e.target.value };
                return { ...draft, sentNumber: e.target.value };
              })}
              data-testid={dataTestIdDeclarationRefNumberInput}
            />

          </Field>

          <Field label={tr('IncotermsTag.sentCarrierUpdateKey', 'Update key')}>
            <InputText
              value={internalValue?.sentCarrierUpdateKey}
              onChange={e => setInternalValue(draft => {
                if (!draft) return { sentCarrierUpdateKey: e.target.value };
                return { ...draft, sentCarrierUpdateKey: e.target.value };
              })}
              data-testid={dataTestIdCarrierUpdateKeyInput}
            />
          </Field>
        </>
      </ButtonTag>
    </>);

};

export default PolandSentTag;